/* Omnitub — interactive 3D on the product page.

   1) AUTO-LOAD the model when the gallery scrolls into view.
      Dawn's DeferredMedia (main.js) only attaches an IntersectionObserver when the element
      has NO `.js-load-media` poster button — and product-media.liquid ALWAYS renders one for
      models. Net effect: the 3D was permanently click-gated. Customers landed on a static
      poster JPG that looked like just another photo, so nobody discovered the model. We reuse
      Dawn's own loadContent() API (no fork) to load it live once it's near the viewport, so
      the customer arrives on a tub they can already drag and spin.
   2) RENDER QUALITY on every <model-viewer>: tone-mapping + exposure + soft grounded shadow +
      neutral studio env, so the white tub reads realistically instead of flat grey.

   No interaction hint: the model turns on load, which already shows it's interactive.
   Deliberately touches NOTHING about AR or the AR button — those stay fully stock. */
(function () {
  // Per-model INITIAL camera overrides, keyed on a GLB filename fragment (operator 20 Jul 2026).
  // The 3000×2000 step-entry is 3 m long but the well is only visible from above — at the stock
  // low orbit (~15° above horizon) the viewer opens on a featureless white slab ("white blur").
  // Start it high enough to look INTO the well; the customer can still orbit anywhere.
  var ORBITS = { 'stepentry3000': '25deg 50deg 112%' };
  function orbitFor(mv) {
    var src = mv.getAttribute('src') || '';
    for (var k in ORBITS) { if (src.indexOf(k) > -1) return ORBITS[k]; }
    return null;
  }
  function cfg(mv) {
    if (!mv || mv.__omniCfg) return;
    mv.__omniCfg = true;
    mv.setAttribute('tone-mapping', 'commerce');
    mv.setAttribute('exposure', '1.05');
    mv.setAttribute('shadow-intensity', '1.15');
    mv.setAttribute('shadow-softness', '0.9');
    mv.setAttribute('environment-image', 'neutral');
    mv.setAttribute('min-field-of-view', '22deg');
    mv.setAttribute('max-field-of-view', '45deg');
    var orb = orbitFor(mv);
    if (orb) { mv.setAttribute('camera-orbit', orb); }
    else {
      // src can arrive after the node (deferred load) — re-check once the model loads
      mv.addEventListener('load', function () {
        var o = orbitFor(mv); if (o && !mv.__omniOrb) { mv.__omniOrb = true; mv.setAttribute('camera-orbit', o); }
      }, { once: true });
    }
    // No "drag to spin" hint (operator 16 Jul 2026): the model already turns on load, which
    // shows it's interactive — a label that appears then fades is just clutter.
  }

  function autoload(pm) {
    if (!pm || pm.__omniAuto) return;
    pm.__omniAuto = true;
    // Returns true only once the model ACTUALLY loaded. loadContent() lives on Dawn's
    // DeferredMedia base class, so it does not exist until the custom element is upgraded —
    // this script runs at DOMContentLoaded, which is EARLIER than that. Firing blind here
    // silently no-ops (and must never unobserve, or it never retries).
    var fire = function () {
      if (pm.getAttribute('loaded') !== null) return true;
      if (typeof pm.loadContent !== 'function') return false;
      try { pm.loadContent(false, false, 'observer'); } catch (e) { return false; }
      return pm.getAttribute('loaded') !== null;
    };
    // Plain rect check, NOT IntersectionObserver: the gallery is a <ul class="media-viewer">
    // slider that clips its children, and IO never fires for the model inside it (verified on
    // the live PDP — a fresh observer got zero callbacks while the element sat mid-viewport).
    // A rect test against the viewport is immune to that.
    var start = function () {
      var check = function () {
        var r = pm.getBoundingClientRect();
        if (r.height === 0 && r.width === 0) return;                  // not laid out yet
        var near = r.bottom > -400 && r.top < (window.innerHeight + 400);
        if (near && fire()) {
          window.removeEventListener('scroll', check);
          window.removeEventListener('resize', check);
        }
      };
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();                                                        // already onscreen? go now
      setTimeout(check, 600);                                         // after layout settles
    };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('product-model').then(start, start);
    } else { start(); }
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.tagName === 'MODEL-VIEWER') cfg(root);
    if (root.tagName === 'PRODUCT-MODEL') autoload(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('model-viewer').forEach(cfg);
      root.querySelectorAll('product-model').forEach(autoload);
    }
  }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) { scan(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') scan(document.body);
  else document.addEventListener('DOMContentLoaded', function () { scan(document.body); });
})();

